
<script setup>
import SearchWidget from '@/Components/Search/Widget.vue';
import LayoutSearch from '@/Layouts/Search.vue';
import CareerListItem from '@/Components/List/Item/Career.vue';
import PaginatedList from '@/Components/List/Paginated.vue';
import { ref, computed } from 'vue';
import Heading from '@/Components/Heading.vue';
import { Head, usePage } from '@inertiajs/vue3';

const props = defineProps({
  careers: {
    type: Object,
    required: true
  },
  queryObject: {
    type: Object,
    required: true,
  }
});

const activeTab = ref('careers');

const page = usePage();

const context = computed(() => page.props?.context);
const providerName = context.value.name;
</script>

<template>
  <Head>
    <title>Search Careers - {{ providerName }}</title>
    <meta name="description" :content="`Career Search Results - ${providerName}`">
  </Head>
  <LayoutSearch>
    <template #hero>
      <SearchWidget v-model="activeTab" :query-object="queryObject"/>
    </template>
    <template #content>
      <div v-if="activeTab != 'careers'">
        <div class="py-32">
          <Heading
            class="text-center"
            size="h2"
            style-size="h1"
          >
            Start searching {{ activeTab }}
          </Heading>
        </div>
      </div>
      <PaginatedList
        v-else
        slug="careers"
        list-name="careers"
        :current-page="careers.meta?.page ?? 1"
        :total-results="careers.meta?.total ?? 0"
        :query-object="queryObject"
      >
        <CareerListItem
          v-for="career, index in careers.data"
          :key="`career-${index}`"
          :career="career"
        />
      </PaginatedList>
    </template>
  </LayoutSearch>
</template>

